import { Collapse, Text } from 'components';
import React from 'react';

const Instructions: React.FC = () => (
    <Collapse>
      <Collapse.Panel header="Instructions" key="1">
        <Text>
          1. First you must select the roster user of the user you are
          interested in. The roster user can be selected via their mls number +
          board (board is optional but is needed for narrowing when there are
          multiple rosters with the same mls number). In extremely rare
          scenarios where there are two roster users with the same mls number
          and board, you will need to specify the roster user&apos;s unique MLS
          identifier (mlsUniqueId) to guarantee the right roster entry is found.
          You must specify an mls number or a unique identifier. Only one field
          will be used for searching (priority is given to the unique
          identifier). Click Find Roster to select the roster user.
          <br />
          <br />
          2. If a roster entry was found, then their data will be displayed and
          you will be able to make updates to it if you want to simulate a
          change in feed data. Clicking submit will perform any updates you
          made. If the updates include a new <kbd>boardId</kbd> and{' '}
          <kbd>mlsUniqueId</kbd> combination, then a brand new roster entry will
          be added to the roster. You can click Find Roster again to see if your
          updates were made correctly.
          <br />
          <br />
          3. Note that any changes to MLS identifiers such as <kbd>
            mlsType
          </kbd>{' '}
          will be ignored to prevent cross-MLS roster insertions. The list of
          ignored fields are listed below once a roster entry is selected. If
          you want to create a roster entry for a specific MLS, you will first
          have to select a roster entry in that MLS. Also this qa page is not
          capable of removing fields. If you need to remove a certain field, you
          will need to create a new roster entry with the fields removed.
        </Text>
      </Collapse.Panel>
    </Collapse>
  );

export default Instructions;
